"use strict";

var __assign = this && this.__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];
      for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
    }
    return t;
  };
  return __assign.apply(this, arguments);
};
var __createBinding = this && this.__createBinding || (Object.create ? function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  var desc = Object.getOwnPropertyDescriptor(m, k);
  if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
    desc = {
      enumerable: true,
      get: function () {
        return m[k];
      }
    };
  }
  Object.defineProperty(o, k2, desc);
} : function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  o[k2] = m[k];
});
var __setModuleDefault = this && this.__setModuleDefault || (Object.create ? function (o, v) {
  Object.defineProperty(o, "default", {
    enumerable: true,
    value: v
  });
} : function (o, v) {
  o["default"] = v;
});
var __importStar = this && this.__importStar || function (mod) {
  if (mod && mod.__esModule) return mod;
  var result = {};
  if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
  __setModuleDefault(result, mod);
  return result;
};
var __rest = this && this.__rest || function (s, e) {
  var t = {};
  for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
  }
  return t;
};
Object.defineProperty(exports, "__esModule", {
  value: true
});
var React = __importStar(require("react"));
function UndrawAddTasks(p) {
  var primaryColor = p.primaryColor,
    height = p.height,
    style = p.style,
    props = __rest(p, ["primaryColor", "height", "style"]);
  var styleProps = __assign({
    width: '100%',
    height: height
  }, style);
  return React.createElement("svg", __assign({
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    viewBox: "0 0 609.767 727.778",
    style: styleProps
  }, props), React.createElement("path", {
    d: "M362.89 172.947h-4V63.402A63.402 63.402 0 00295.49 0H63.402A63.402 63.402 0 000 63.402v600.974a63.402 63.402 0 0063.402 63.402h232.086a63.402 63.402 0 0063.402-63.402V250.923h4z",
    fill: "#3f3d56"
  }), React.createElement("path", {
    d: "M345.397 63.844v600.09a47.345 47.345 0 01-40.83 46.9 46.768 46.768 0 01-6.52.45H64.837a46.769 46.769 0 01-6.52-.45 47.345 47.345 0 01-40.82-46.9V63.844a47.35 47.35 0 0147.35-47.35h28.29a22.486 22.486 0 0020.83 30.99h132.96a22.48 22.48 0 0020.82-30.99h30.3a47.35 47.35 0 0147.35 47.35z",
    fill: "#fff"
  }), React.createElement("path", {
    d: "M345.397 511.834v152.1a47.345 47.345 0 01-40.83 46.9H58.317a47.345 47.345 0 01-40.82-46.9v-152.1z",
    fill: "#e6e6e6"
  }), React.createElement("circle", {
    cx: 181.447,
    cy: 611.334,
    r: 31.32,
    fill: "#fff"
  }), React.createElement("path", {
    fill: "#e6e6e6",
    d: "M200.239 611.334h-16.912v-16.913h-3.759v16.913h-16.913v3.758h16.913v16.913h3.759v-16.913h16.912v-3.758z"
  }), React.createElement("path", {
    d: "M237.06 414.437v28.131l-14.445 16.726s-6.082-2.28-6.082-17.486l-2.281-22.049z",
    fill: "#ffb9b9"
  }), React.createElement("path", {
    d: "M222.615 442.568s23.569-15.966 24.33-21.288 22.604-29.279 28.89-14.445c5.932 13.999-18.068 25.999-18.068 25.999s-16.905 31.022-28.31 30.262-11.404-15.206-6.842-20.528zM208.93 613.633l-2.281 13.686 12.165-3.042v-10.644h-9.884z",
    fill: "#ffb9b9"
  }), React.createElement("path", {
    d: "M211.21 621.236s14.06-8.33 14.633-4.545 6.656 18.23 9.697 19.75 6.842 18.248 0 17.487c-5.3-.589-24.738-10.755-33.234-15.31a4.643 4.643 0 01-1.997-6.067 9.579 9.579 0 001.018-2.952c0-1.52 9.884-8.363 9.884-8.363z",
    fill: "#2f2e41"
  }), React.createElement("path", {
    d: "M204.368 466.897s55.501 25.85 50.179 45.618-25.09 103.399-25.09 103.399-22.048 5.322-23.568 0 14.445-88.194 12.924-91.235-29.65-22.808-29.65-22.808l-57.783-24.33 24.33-22.808z",
    fill: "#2f2e41"
  }), React.createElement("path", {
    fill: "#ffb9b9",
    d: "M246.184 618.195l6.843 17.487-12.165 5.322-7.603-13.685 12.925-9.124zM205.128 342.21s-6.842 9.123-1.52 13.685 1.52 21.288 1.52 21.288l-6.842 19.007-27.37-5.322v-31.171l1.52-15.206s13.685-12.925 15.206-22.809 17.486 20.528 17.486 20.528z"
  }), React.createElement("path", {
    d: "M159.511 460.815s35.734 39.535 35.734 41.056 19.007 32.692 19.007 32.692l37.254 82.871s-14.446 19.768-20.528 18.247-49.419-89.714-49.419-89.714-7.603-19.767-28.13-24.329-36.494-20.528-28.891-38.775 34.973-22.048 34.973-22.048z",
    fill: "#2f2e41"
  }), React.createElement("circle", {
    cx: 205.128,
    cy: 323.203,
    r: 24.329,
    fill: "#ffb9b9"
  }), React.createElement("path", {
    d: "M204.368 362.738s-3.041 17.486-6.082 19.007-5.322 6.843-12.165-.76-12.925-22.809-12.925-22.809l-23.569 28.891-2.28 79.83s26.61-6.842 34.973 0 26.61 6.083 26.61 6.083l-3.802-15.206 3.041-25.85-.76-23.569-.76-16.726z",
    fill: primaryColor
  }), React.createElement("path", {
    d: "M201.69 349.94s10.28 5.195 11.041 8.236 14.446 9.124 14.446 9.124 5.322 5.322 5.322 8.363-18.247 38.014-18.247 38.014-3.802 23.57-2.281 28.13-3.041 22.05-3.041 22.05l9.123 10.643h-8.363s-9.123-4.562-9.123-6.842 1.52-18.247 2.28-25.09.76-31.172-.76-39.535-.76-30.411-.76-35.733.363-17.36.363-17.36zM178.138 338.396s-3.421.773-13.305 3.814-25.09 7.603-30.411 13.685a94.247 94.247 0 00-9.884 14.446l3.04 54.74s-6.081 11.405-5.321 17.487 6.843 6.843 2.28 19.768-13.684 24.329-5.321 25.85 30.411-3.802 40.295-.76S180.8 476.02 180.8 476.02s-15.206 1.52-12.925-4.562 27.37-74.508 22.049-89.714-11.785-43.349-11.785-43.349z",
    fill: "#3f3d56"
  }), React.createElement("path", {
    d: "M228.697 371.861l3.802 3.042s10.644 38.014 7.603 41.815-27.37 12.165-28.891 6.843 17.486-51.7 17.486-51.7z",
    fill: "#3f3d56"
  }), React.createElement("path", {
    d: "M116.175 398.471s-11.405 32.693-11.405 41.816 1.52 62.344 1.52 62.344 7.604 31.945 23.57 22.822-6.843-24.343-6.843-24.343.76-60.062 6.843-68.426 8.363-20.527 8.363-20.527z",
    fill: "#ffb9b9"
  }), React.createElement("path", {
    d: "M240.862 634.921s11.404-6.082 13.685-1.52 14.446 29.65 12.925 32.692-9.884 15.206-19.768 12.165-10.644-19.008-10.644-19.008l-.76-18.247zM209.892 317.326c-1.676.789-3.664 1.26-4.717 2.784-.78 1.13-.858 2.596-1.427 3.845a5.437 5.437 0 01-6.995 2.558 6.032 6.032 0 00-2.46-3.735 3.583 3.583 0 00-4.254.233c-1.567 1.494-1.012 4.1-1.744 6.137a12.953 12.953 0 01-2.786 3.82c-1.664 1.92-2.99 4.173-4.994 5.735s-5.043 2.238-7.033.66c-1.675-1.328-2.022-3.776-1.615-5.874s1.415-4.029 1.983-6.088c1.848-6.692-1.098-13.836-.186-20.718 1.167-8.819 8.663-15.784 17.029-18.807a19.922 19.922 0 0110.994-1.165c3.826.854 7.094 3.29 10.758 4.683 3.919 1.49 8.18 1.75 12.28 2.62s8.321 2.556 10.7 6.007c1.66 2.407 2.231 5.397 3.606 7.977a14.311 14.311 0 007.25 6.494l-4.336-.247a12.777 12.777 0 003.454 5.041 9.27 9.27 0 01-6-.793 6.523 6.523 0 002.237 4.676c-3.336-.1-6.853-.254-9.672-2.041-1.38-.875-2.506-2.094-3.806-3.086-2.769-2.115-6.204-3.118-9.553-4.08-1.76-.504-3.876-1.206-5.466-.075-1.325.942-1.534 2.633-3.247 3.44z",
    fill: "#2f2e41"
  }), React.createElement("path", {
    d: "M135.942 361.217l-11.404 9.124-15.206 34.973s21.288 16.726 26.61 14.446 14.446-42.577 14.446-42.577z",
    fill: "#3f3d56"
  }), React.createElement("ellipse", {
    cx: 577.427,
    cy: 499.71,
    rx: 0.442,
    ry: 0.376,
    transform: "rotate(-50.158 337.869 771.955)",
    fill: "#f2f2f2"
  }), React.createElement("path", {
    d: "M271.614 346.588a4.942 4.942 0 00-4.936 4.936v82.657a4.942 4.942 0 004.936 4.937h333.217a4.942 4.942 0 004.936-4.937v-82.657a4.942 4.942 0 00-4.936-4.936z",
    fill: "#fff"
  }), React.createElement("path", {
    d: "M271.614 346.588a4.942 4.942 0 00-4.936 4.936v82.657a4.942 4.942 0 004.936 4.937h333.217a4.942 4.942 0 004.936-4.937v-82.657a4.942 4.942 0 00-4.936-4.936z",
    fill: "#e6e6e6"
  }), React.createElement("path", {
    d: "M272.231 433.564h331.983v-81.422H272.23z",
    fill: "#fff"
  }), React.createElement("circle", {
    cx: 314.809,
    cy: 392.853,
    r: 25.917,
    fill: primaryColor
  }), React.createElement("path", {
    d: "M374.665 375.575a4.32 4.32 0 000 8.639h203.632a4.32 4.32 0 000-8.64zM374.665 401.492a4.32 4.32 0 000 8.639h203.632a4.32 4.32 0 000-8.64z",
    fill: "#e6e6e6"
  }), React.createElement("path", {
    d: "M58.32 96.834a3.647 3.647 0 00-3.642 3.643v60.998a3.647 3.647 0 003.643 3.643h245.902a3.647 3.647 0 003.643-3.643v-60.998a3.647 3.647 0 00-3.643-3.643z",
    fill: "#fff"
  }), React.createElement("path", {
    d: "M58.32 96.834a3.647 3.647 0 00-3.642 3.643v60.998a3.647 3.647 0 003.643 3.643h245.902a3.647 3.647 0 003.643-3.643v-60.998a3.647 3.647 0 00-3.643-3.643z",
    fill: "#e6e6e6"
  }), React.createElement("path", {
    d: "M58.776 161.02h244.992v-60.088H58.776z",
    fill: "#fff"
  }), React.createElement("circle", {
    cx: 90.197,
    cy: 130.976,
    r: 19.126,
    fill: primaryColor
  }), React.createElement("path", {
    d: "M134.368 118.225a3.188 3.188 0 000 6.376h150.274a3.188 3.188 0 100-6.376zM134.368 137.351a3.188 3.188 0 000 6.375h150.274a3.188 3.188 0 100-6.375z",
    fill: "#e6e6e6"
  }), React.createElement("path", {
    d: "M58.32 205.834a3.647 3.647 0 00-3.642 3.643v60.998a3.647 3.647 0 003.643 3.643h245.902a3.647 3.647 0 003.643-3.643v-60.998a3.647 3.647 0 00-3.643-3.643z",
    fill: "#fff"
  }), React.createElement("path", {
    d: "M58.32 205.834a3.647 3.647 0 00-3.642 3.643v60.998a3.647 3.647 0 003.643 3.643h245.902a3.647 3.647 0 003.643-3.643v-60.998a3.647 3.647 0 00-3.643-3.643z",
    fill: "#e6e6e6"
  }), React.createElement("path", {
    d: "M58.776 270.02h244.992v-60.088H58.776z",
    fill: "#fff"
  }), React.createElement("circle", {
    cx: 90.197,
    cy: 239.976,
    r: 19.126,
    fill: primaryColor
  }), React.createElement("path", {
    d: "M134.368 227.225a3.188 3.188 0 000 6.376h150.274a3.188 3.188 0 100-6.376zM134.368 246.351a3.188 3.188 0 000 6.375h150.274a3.188 3.188 0 100-6.375z",
    fill: "#e6e6e6"
  }));
}
exports.default = UndrawAddTasks;